import type { MouseEventHandler } from 'react'
import { useIntl } from 'react-intl'
import Clickable from 'components/Common/Clickable'
import noop from 'lib/function/noop'
import { TripPlannerLockupLogo } from './Shared'

interface Props {
  className?: string
  onClick?: MouseEventHandler
}

function TripPlannerHomeLogoLink({ className, onClick = noop }: Props) {
  const intl = useIntl()

  return (
    <Clickable
      to="/"
      className={className}
      onClick={onClick}
      aria-label={intl.formatMessage({
        id: '2-Y8YnZ-hkJDzdJ-H2eS',
        defaultMessage: 'Back to homepage',
        description: 'Accessible name for the AI TripPlanner logo link in the header, side nav, menu drawer and mobile header, which goes to the Luxury Escapes homepage',
      })}
    >
      <TripPlannerLockupLogo aria-hidden />
    </Clickable>
  )
}

export default TripPlannerHomeLogoLink
